import React from 'react'
import { Form, Button } from 'semantic-ui-react'

import './Form.css'

// *****************************************************************************
// Sub-component : Form Row
// *****************************************************************************

class FormRow extends React.Component {
  render() {
    return (
      <Form.Field
        as='tr'
        {...this.props}
      >
        {
          React.Children.map(
            this.props.children,
            (child) => (
              <td>
                {child}
              </td>
            )
          )
        }
      </Form.Field>
    )
  }
}

// *****************************************************************************
// Main component : Form
// *****************************************************************************

class FormComponent extends React.Component {
  render() {
    return (
      <Form
        {...this.props}
        className='library-form'
      >
        <table>
          <tbody>
            {this.props.children}
          </tbody>
        </table>
        <Button type='submit' />
      </Form>
    )
  }
}

FormComponent.Row = FormRow

export default FormComponent



// WEBPACK FOOTER //
// ./src/components/elements/Form.js